import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from '../../shared/Constants';

@Injectable()
export class UploadService {

  constructor(private http: HttpClient) { }

  uploadAttachment(file: File) {
    const formData: FormData = new FormData();
    formData.append('uploadFile', file, file.name);
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.post(Constants.URL_BACKEND + '/upload-attachments', formData, { headers: headers });
  }

}



// WEBPACK FOOTER //
// ./src/app/system/services/upload.service.ts